// Ensures the returned promise settles no sooner than `ms` ms after it starts.
// Used to keep short-lived loading indicators visible long enough to register
// visually instead of flashing for a single frame.
export async function withMinDuration<T>(promise: Promise<T>, ms: number): Promise<T> {
    const [result] = await Promise.all([
        promise,
        new Promise((resolve) => window.setTimeout(resolve, ms)),
    ]);
    return result;
}

export const SAVE_INDICATOR_MIN_MS = 1000;
